import { Toasts } from '@fourthwall/components'
import { createQueryClient } from '@fourthwall/utils/dist/queryClient'

export const queryClient = createQueryClient({
  notify: (message) => Toasts.notify(message, { type: 'error' }),
})
